document.addEventListener('DOMContentLoaded', function() {
  var personalizeButton = document.getElementById('personalize-button');

  if (!personalizeButton) {
    return;
  }

  var modal = document.getElementById('personalization-modal');
  var closeButton = document.querySelector('.perfume-modal__close');
  var engravingInput = document.getElementById('engraving-input');
  var engravingPreview = document.getElementById('engraving-preview');
  var confirmButton = document.getElementById('confirm-personalization');
  var giftCheckbox = document.getElementById('gift-wrap-checkbox'); // Correct gift checkbox ID
  var baseImage = document.getElementById('base-image');
  var selectedOptions = {};

  // Move modal to body for proper full-screen display
  if (modal) {
    document.body.appendChild(modal);
  }

  // Function to open modal
  function openModal() {
    modal.style.display = 'block';
    document.body.style.overflow = 'hidden';
    initializeVariantOptions();
  }

  // Function to close modal
  function closeModal() {
    modal.style.display = 'none';
    document.body.style.overflow = '';
  }

  // Open modal on button click
  personalizeButton.addEventListener('click', function() {
    openModal();
  });

  // Close modal on close button click
  closeButton.addEventListener('click', function() {
    closeModal();
  });

  // Close modal when clicking outside it
  window.addEventListener('click', function(event) {
    if (event.target == modal) {
      closeModal();
    }
  });

  // Update engraving preview with uppercase text
  engravingInput.addEventListener('input', function() {
    this.value = this.value.toUpperCase(); // Convert input to uppercase
    engravingPreview.textContent = this.value;
  });

  // Restrict input to specific characters
  engravingInput.addEventListener('keypress', function(event) {
    var char = String.fromCharCode(event.which);
    if (!/^[a-zA-Z0-9.,:«()!?+\-*/=]+$/.test(char)) {
      event.preventDefault();
    }
  });

  // Initialize variant selection logic
  function initializeVariantOptions() {
    var optionContainers = document.querySelectorAll('.perfume-modal__option-values');
    optionContainers.forEach(function(container) {
      var optionIndex = container.getAttribute('data-option-index');
      var buttons = container.querySelectorAll('.perfume-modal__option-value');
      selectedOptions[optionIndex] = buttons[0].getAttribute('data-value'); // Default selection

      buttons.forEach(function(button) {
        button.addEventListener('click', function() {
          buttons.forEach(function(btn) {
            btn.classList.remove('active');
          });
          button.classList.add('active');
          selectedOptions[optionIndex] = button.getAttribute('data-value');
          updateVariant();
        });
      });

      buttons[0].classList.add('active');
    });

    updateVariant();
  }

  // Update variant based on selected options
  function updateVariant() {
    var options = [];
    var optionCount = Object.keys(selectedOptions).length;
    for (var i = 0; i < optionCount; i++) {
      options.push(selectedOptions[i]);
    }

    var selectedVariant = null;
    for (var i = 0; i < productVariants.length; i++) {
      var variant = productVariants[i];
      var match = true;
      for (var j = 0; j < variant.options.length; j++) {
        if (variant.options[j] != options[j]) {
          match = false;
          break;
        }
      }
      if (match) {
        selectedVariant = variant;
        break;
      }
    }

    if (selectedVariant) {
      if (selectedVariant.available) {
        confirmButton.disabled = false;
        confirmButton.textContent = 'Ajouter au panier';
      } else {
        confirmButton.disabled = true;
        confirmButton.textContent = 'Indisponible';
      }
      confirmButton.setAttribute('data-variant-id', selectedVariant.id);
    } else {
      confirmButton.disabled = true;
      confirmButton.textContent = 'Indisponible';
    }

    updateOptionAvailability();
  }

  // Update availability of options
  function updateOptionAvailability() {
    var optionContainers = document.querySelectorAll('.perfume-modal__option-values');
    optionContainers.forEach(function(container) {
      var optionIndex = parseInt(container.getAttribute('data-option-index'));
      var buttons = container.querySelectorAll('.perfume-modal__option-value');

      buttons.forEach(function(button) {
        var value = button.getAttribute('data-value');
        var testOptions = [];

        for (var i = 0; i < Object.keys(selectedOptions).length; i++) {
          if (i === optionIndex) {
            testOptions.push(value);
          } else {
            testOptions.push(selectedOptions[i]);
          }
        }

        var variantExists = productVariants.some(function(variant) {
          var match = true;
          for (var j = 0; j < variant.options.length; j++) {
            if (variant.options[j] != testOptions[j]) {
              match = false;
              break;
            }
          }
          return match && variant.available;
        });

        if (variantExists) {
          button.classList.remove('disabled');
          button.disabled = false;
        } else {
          button.classList.add('disabled');
          button.disabled = true;
        }
      });
    });
  }

  // Add to cart with engraving and gift options
  confirmButton.addEventListener('click', function() {
    var engravingText = engravingInput.value.trim();
    var isGiftSelected = giftCheckbox.checked;

    if (engravingText.length === 0) {
      alert('Veuillez entrer votre texte.');
      return;
    }
    if (engravingText.length > 3) {
      alert('Veuillez entrer un maximum de 3 caractères.');
      return;
    }
    if (!/^[A-Z0-9.,:«()!?+\-*/=]{1,3}$/.test(engravingText)) {
      alert('Seules les lettres, les chiffres, et les caractères spéciaux autorisés sont permis.');
      return;
    }

    var variantId = confirmButton.getAttribute('data-variant-id');

    var formData = {
      items: [{
        id: variantId,
        quantity: 1,
        properties: {
          'Texte gravé': engravingText,
          'Emballage Cadeau': isGiftSelected ? 'Oui' : 'Non'
        }
      }]
    };

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(formData)
    })
    .then(function(response) {
      if (!response.ok) {
        return response.json().then(function(err) {
          throw new Error(err.description);
        });
      }
      return response.json();
    })
    .then(function(data) {
      closeModal();
      window.location.href = '/cart';
    })
    .catch(function(error) {
      alert('Erreur : ' + error.message);
    });
  });
});
